import { PinCodeWidgetParams } from './pin-code.model';

export const PIN_CODE_3_DIGIT: PinCodeWidgetParams = {
  digitCount: 3,
  allowRepeats: true,
};

export const PIN_CODE_4_DIGIT: PinCodeWidgetParams = {
  digitCount: 4,
  allowRepeats: true,
};

export const PIN_CODE_3_NO_REPEATS: PinCodeWidgetParams = {
  digitCount: 3,
  allowRepeats: false,
};

export const PIN_CODE_3_ODD_FIRST_SQUARE_LAST: PinCodeWidgetParams = {
  digitCount: 3,
  allowRepeats: true,
  restrictions: {
    0: { label: 'odd', allowedDigits: [1, 3, 5, 7, 9] },
    2: { label: 'square', allowedDigits: [0, 1, 4, 9] },
  },
};

export const PIN_CODE_3_EVEN_FIRST_PRIME_LAST: PinCodeWidgetParams = {
  digitCount: 3,
  allowRepeats: true,
  restrictions: {
    0: { label: 'even', allowedDigits: [0, 2, 4, 6, 8] },
    2: { label: 'prime', allowedDigits: [2, 3, 5, 7] },
  },
};

export const PIN_CODE_PRESETS: Record<string, Record<string, unknown>> = {
  '3-digit': { params: PIN_CODE_3_DIGIT },
  '4-digit': { params: PIN_CODE_4_DIGIT },
  '3-digit-no-repeats': { params: PIN_CODE_3_NO_REPEATS },
  '3-digit-odd-first-square-last': { params: PIN_CODE_3_ODD_FIRST_SQUARE_LAST },
  '3-digit-even-first-prime-last': { params: PIN_CODE_3_EVEN_FIRST_PRIME_LAST },
};
